import { Component, OnInit } from '@angular/core';
import { AccessLevel } from '../../../common/enums/access-level.enum';
import { AuthorizationPipe } from '../../../common/pipes/authorization.pipe';
import { CommonService } from '../../../shared/services/common.service';
import { Permission } from './../../../common/enums/permission.enum';

@Component({
    selector: 'department-tabs',
    templateUrl: '../../templates/template1/views/admin/department-tabs.html',
    styleUrls: ['../../templates/template1/themes/default/css/admin.component.less'],
    providers: [AuthorizationPipe]
})
export class DepartmentTabsComponent implements OnInit {

    DepartmentPermissions: any[] = [Permission.MANAGE_DEPARTMENT_CREATE];
    activeTab: number;
    addDepartmentPermission: boolean;

    constructor(private _commonService: CommonService){   }

    ngOnInit() {
        this.addDepartmentPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.DepartmentPermissions[0] + ']'),AccessLevel.Account); 
        this.activeTab = 1;
    }

    /**
     * @description
     * @date 2020-03-05
     * @param {number} tab
     * @memberof DepartmentTabsComponent
     */
    selectTab(tab: number) {
        this.activeTab = tab;
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/admin/department-tabs.component.ts